import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import SwiperCore, { Pagination } from "swiper";
import { ChevronRight } from "lucide-react"; // You can also use any icon you prefer

SwiperCore.use([Pagination]);

const cardData = [
  {
    title: "QR Scan Ordering. Digital Menu.",
    subtitle:
      "Let customers scan QR codes to browse menus, place orders, and pay instantly. No lines, no waiting — faster service, happier guests.",
    image: "/images/galery/order-table-qr.jpg",
  },
  {
    title: "Automatic Loyalty Stamps.",
    subtitle:
      "Reward your regular customers with digital stamp cards that track every visit automatically. Build loyalty and keep customers coming back.",
    image:
      "https://images.pexels.com/photos/12935064/pexels-photo-12935064.jpeg",
  },
  {
    title: "Real-time Kitchen Printing.",
    subtitle:
      "Orders go directly from the customer’s phone to your kitchen printer or display — fast, accurate, and fully automated for your food stall.",
    image: "https://images.pexels.com/photos/7439122/pexels-photo-7439122.jpeg",
  },
  {
    title: "Online Pre-order & Pickup.",
    subtitle:
      "Allow customers to place orders in advance and pick up when ready. Reduce congestion, serve more customers, and keep lines moving.",
    image: "/images/galery/menubook.png",
  },
];

const ThirdNightMarket = () => {
  const [expandedCard, setExpandedCard] = useState(null);

  const toggleExpand = (index) => {
    setExpandedCard(expandedCard === index ? null : index);
  };

  return (
    <div className="bg-black py-20 px-4">
      <div className="max-w-7xl mx-auto text-center mb-16">
        <h2 className="text-4xl md:text-5xl font-semibold text-text mb-4">
          More orders. Happier customers.
        </h2>
        <p className="text-textGray text-lg max-w-3xl mx-auto">
          Let customers scan, order, and pay instantly. With QR code menus,
          real-time kitchen printing, and fast pickup, Lokalai helps your food
          stall serve more people, reduce waiting, and keep lines moving.
        </p>
      </div>

      <div className="max-w-7xl mx-auto">
        <div className="max-w-7xl mx-auto relative">
          <Swiper
            pagination={{ clickable: true }}
            spaceBetween={30}
            slidesPerView={1}
            breakpoints={{
              640: { slidesPerView: 1.2 },
              768: { slidesPerView: 2.2 },
              1024: { slidesPerView: 3.2 },
              1280: { slidesPerView: 4.2 },
            }}
          >
            {cardData.map((card, index) => (
              <SwiperSlide key={index}>
                <div
                  className="bg-dry text-text rounded-3xl p-8 h-full flex flex-col justify-between shadow-xl min-h-[500px] cursor-pointer transition-all duration-300"
                  onClick={() => toggleExpand(index)}
                >
                  <div>
                    <h3 className="text-xl font-semibold whitespace-pre-line mb-4">
                      {card.title}
                    </h3>
                    <p
                      className={`text-sm mb-6 transition-all duration-300 ${
                        expandedCard === index ? "" : "line-clamp-3"
                      }`}
                    >
                      {card.subtitle}
                    </p>
                  </div>
                  <div className="w-full h-[300px] rounded-xl overflow-hidden mb-4">
                    <img
                      src={card.image}
                      alt={card.title}
                      className="w-full h-full object-cover grayscale"
                    />
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Conditional right arrow */}
          {cardData.length < 5 && (
            <div className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-white rounded-full p-2 shadow-lg cursor-pointer">
              <ChevronRight className="text-text" size={24} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ThirdNightMarket;
